(function () {
  var App = window.OptiplexAmblyopiaParentApp;
  var Lifecycle = window.OptiplexAmblyopiaLifecycle || {};
  if (!App || typeof App.boot !== "function") return;
  if (document.readyState === "loading") Lifecycle.addManagedListener({ lifecycle: null }, "app", document, "DOMContentLoaded", App.boot, { once: true });
  else App.boot();
})();
